
import PrismicData from '~/assets/js/prismic-controller.js'
export default {
  name: 'Download',
  nuxtI18n: {
    paths: {
      en: '/download',
      it: '/download',
      de: '/download'
    }
  },
  computed: {
    filter(){
      return this.$route.hash && this.$route.hash.length ? this.$route.hash.substring(1) : false
    }
  },
  async asyncData({ $prismic, app, store, params, error, req }) {
    const lang = app.i18n.locales.filter(i => i.iso.includes(app.i18n.locale))[0].iso
    try {
      const results = await $prismic.api.query($prismic.predicates.at('my.download_page.uid', 'download'), { lang })
      const page = results.results[0]
      return {
        document: page.data,
        slices: page.data.body || [],
        documentUid: page.uid,
        documentLang: page.lang.substr(0, 2)
      }
    } catch (e) {
      error({ message: JSON.stringify(e), statusCode: 404 })
    }
  },
  head() {
    return PrismicData.seo(this.$nuxtI18nHead({ addSeoAttributes: true }), this.document, this.documentUid, this.documentLang)
  }
}
